import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import apiService from '../services/api'

// 异步 thunks
export const fetchCompareData = createAsyncThunk(
  'analytics/fetchCompare',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.analytics.compare(params)
      return response.data.data
    } catch (error) {
      return rejectWithValue(error.apiMessage || '获取对比数据失败')
    }
  }
)

export const fetchAttributionData = createAsyncThunk(
  'analytics/fetchAttribution',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.analytics.attribution(params)
      return response.data.data
    } catch (error) {
      return rejectWithValue(error.apiMessage || '获取归因数据失败')
    }
  }
)

export const fetchForecastData = createAsyncThunk(
  'analytics/fetchForecast',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.analytics.forecast(params)
      return response.data.data
    } catch (error) {
      return rejectWithValue(error.apiMessage || '获取预测数据失败')
    }
  }
)

const initialState = {
  // 对比分析
  compare: {
    data: null,
    loading: false,
    error: null,
  },
  // 归因分析
  attribution: {
    data: null,
    loading: false,
    error: null,
  },
  // 趋势预测
  forecast: {
    data: null,
    loading: false,
    error: null,
  },
}

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    clearCompareData: (state) => {
      state.compare.data = null
      state.compare.error = null
    },
    clearAttributionData: (state) => {
      state.attribution.data = null
      state.attribution.error = null
    },
    clearForecastData: (state) => {
      state.forecast.data = null
      state.forecast.error = null
    },
  },
  extraReducers: (builder) => {
    // 对比分析
    builder
      .addCase(fetchCompareData.pending, (state) => {
        state.compare.loading = true
        state.compare.error = null
      })
      .addCase(fetchCompareData.fulfilled, (state, action) => {
        state.compare.loading = false
        state.compare.data = action.payload
      })
      .addCase(fetchCompareData.rejected, (state, action) => {
        state.compare.loading = false
        state.compare.error = action.payload
      })

    // 归因分析
    builder
      .addCase(fetchAttributionData.pending, (state) => {
        state.attribution.loading = true
        state.attribution.error = null
      })
      .addCase(fetchAttributionData.fulfilled, (state, action) => {
        state.attribution.loading = false
        state.attribution.data = action.payload
      })
      .addCase(fetchAttributionData.rejected, (state, action) => {
        state.attribution.loading = false
        state.attribution.error = action.payload
      })

    // 趋势预测
    builder
      .addCase(fetchForecastData.pending, (state) => {
        state.forecast.loading = true
        state.forecast.error = null
      })
      .addCase(fetchForecastData.fulfilled, (state, action) => {
        state.forecast.loading = false
        state.forecast.data = action.payload
      })
      .addCase(fetchForecastData.rejected, (state, action) => {
        state.forecast.loading = false
        state.forecast.error = action.payload
      })
  },
})

export const { clearCompareData, clearAttributionData, clearForecastData } = analyticsSlice.actions

export default analyticsSlice.reducer

// 选择器
export const selectCompare = (state) => state.analytics.compare
export const selectAttribution = (state) => state.analytics.attribution
export const selectForecast = (state) => state.analytics.forecast
